/**
 * @file HeaderSection.jsx
 * @author Rishikesh
 * @date 2024-09-11
 * @description Header component of lead-details.
 */
import {
  Breadcrumbs,
  Button,
  Divider,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { Link, useNavigate } from "react-router-dom";

export const HeaderSection = ({
  isLoading,
  lead,
  handleCall,
  handleArchive,
}) => {
  const navigate = useNavigate();
  return (
    <>
      {isLoading ? (
        <Skeleton variant="rounded" width={180} height={24} />
      ) : (
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/candidates">Candidate</Link>
          <Typography sx={{ color: "text.primary" }}>Details</Typography>
        </Breadcrumbs>
      )}

      <Stack display="flex" direction={{ xs: "column", md: "row" }} gap={2}>
        <Stack flex={1}>
          {isLoading ? (
            <Skeleton
              sx={{ mt: 3 }}
              variant="rounded"
              width={390}
              height={24}
            />
          ) : (
            <Typography
              sx={{ mt: 2 }}
              fontWeight={700}
              fontSize={24}
              color="#222222"
            >
              Candidate Name - {lead?.name || "Lead Name"}
            </Typography>
          )}
          {isLoading ? (
            <Skeleton
              sx={{ mt: 1 }}
              variant="rounded"
              width={390}
              height={24}
            />
          ) : (
            <Stack display="flex" mb={0.2} direction="row" spacing={2}>
              <Typography fontSize={14} color="#222222">
                {lead?.email}
              </Typography>
              <Divider orientation="vertical" flexItem />
              <Typography fontSize={14} color="#222222">
                {lead?.personalphone}
              </Typography>
            </Stack>
          )}
        </Stack>
        {isLoading ? (
          <Skeleton
            sx={{ alignSelf: "end", mb: 1 }}
            variant="rounded"
            width={350}
            height={42}
          />
        ) : (
          <Stack
            display="flex"
            spacing={1}
            direction="row"
            alignSelf={{ xs: "start", md: "end" }}
            pb={1}
          >
            <Button variant="contained" color="success" onClick={handleCall}>
              Call
            </Button>
            <Button
              variant="outlined"
              onClick={() =>
                navigate(
                  `/candidates/candidate-lifecycle/${lead.candidateuuid}`,
                  {
                    state: { lead: lead },
                  }
                )
              }
              style={{
                backgroundColor: "#FCF2DF",
                color: "black",
                borderWidth: 0.5,
                borderColor: "#BD8623",
                textTransform: "none",
              }}
            >
              View Lifecycle
            </Button>
          </Stack>
        )}
      </Stack>

      {!isLoading && <Divider />}
    </>
  );
};
